import { render } from "./AdminEntityIndex.vue?vue&type=template&id=6947a7b3"
import script from "./AdminEntityIndex.vue?vue&type=script&lang=js"
export * from "./AdminEntityIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__